export type UKCountry = 'england' | 'scotland' | 'wales' | 'northern_ireland';

export const NHS_COUNTRIES: UKCountry[] = ['england'];

// Maps URL vanity segment → UKCountry.
// Confirmed against develop/production on 2026-05-19.
// Note: Scotland uses 'nhs-sleepio', not 'nhs-scotland'.
export const VANITY_TO_COUNTRY: Record<string, UKCountry> = {
  'nhs-england': 'england',
  'nhs-sleepio': 'scotland',
  wales: 'wales',
  'northern-ireland': 'northern_ireland',
};

// Destination path segment (vanity/sceneSetId) for each country.
// Used by CountrySelectorGuard to skip the selector when cookie exists.
// SceneSet IDs are production values; dev may differ.
export const COUNTRY_TO_DESTINATION: Record<UKCountry, string> = {
  england: 'nhs-england/407',
  scotland: 'nhs-sleepio/171',
  wales: 'wales/408',
  northern_ireland: 'northern-ireland/409',
};

export const isValidUKCountry = (v: unknown): v is UKCountry =>
  Object.values(VANITY_TO_COUNTRY).includes(v as UKCountry);
